import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function RemoteControlIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g fill={color}>
        <path d="m16.65 2.91904c-1.1791.10696-2.9097.23086-4.65.23086s-3.47092-.1239-4.65-.23086v18.16176c1.17908-.107 2.9097-.2309 4.65-.2309s3.4709.1239 4.65.2309zm1.35 18.97856c0 .3385-.2776.6064-.6082.6076l-.0668-.003c-1.0532-.1103-3.1891-.3023-5.325-.3023-2.13588 0-4.27177.192-5.325.3023l-.0668.003c-.33063-.0012-.6082-.2691-.6082-.6076v-19.79536c.00004-.3611.31585-.64174.675-.6041 1.05323.11038 3.18912.30176 5.325.30176 2.1359 0 4.2718-.19138 5.325-.30176.3591-.03764.675.243.675.6041z" />
        <path d="m13.8 17.4c0 .9941-.8059 1.8-1.8 1.8s-1.8-.8059-1.8-1.8.8059-1.8 1.8-1.8 1.8.8059 1.8 1.8z" />
        <path d="m10.8 12.3c0 .497-.4029.9-.9.9-.49706 0-.9-.403-.9-.9 0-.4971.40294-.9.9-.9.4971 0 .9.4029.9.9z" />
        <path d="m10.8 9.29997c0 .49705-.4029.90003-.9.90003-.49706 0-.9-.40298-.9-.90003 0-.49706.40294-.9.9-.9.4971 0 .9.40294.9.9z" />
        <path d="m10.8 6.29997c0 .49705-.4029.9-.9.9-.49706 0-.9-.40295-.9-.9 0-.49706.40294-.9.9-.9.4971 0 .9.40294.9.9z" />
        <path d="m15 12.3c0 .497-.4029.9-.9.9s-.9-.403-.9-.9c0-.4971.4029-.9.9-.9s.9.4029.9.9z" />
        <path d="m15 9.29997c0 .49705-.4029.90003-.9.90003s-.9-.40298-.9-.90003c0-.49706.4029-.9.9-.9s.9.40294.9.9z" />
        <path d="m15 6.29997c0 .49705-.4029.9-.9.9s-.9-.40295-.9-.9c0-.49706.4029-.9.9-.9s.9.40294.9.9z" />
      </g>
    </SVGWrapper>
  );
}

export default RemoteControlIcon;
